import React, { useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { AuthContext } from './context/AuthProvider';
import Layout from './container/Layout/Layout';
import {
  LOGIN_PAGE,
  REGISTRATION_PAGE,
  REGISTRATION_PAGE2,
  FORGET_PASSWORD_PAGE,
  HOME_PAGE,
  LISTING_POSTS_PAGE,
  SINGLE_POST_PAGE,
  ADD_HOTEL_PAGE,
  ADD_EVAL_PAGE,
  AGENT_PROFILE_PAGE,
  AGENT_ACCOUNT_SETTINGS_PAGE,
  PRIVACY_PAGE,
  PRICING_PLAN_PAGE,
  EVALUATION_RESULT_PAGE,
  SIGNIN_ESTIMATION_PAGE,
  SIGNUP_ESTIMATION_PAGE,
  AGENT_PROFILE_CONTACT,
  ASSITANT_PAGE,
} from './settings/constant';

/**
 *
 * Public Routes
 *
 */
const Loading = () => null;

const routes = [
  {
    path: HOME_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "Home" */ './container/ZiaHome/Home'),
      loading: Loading,
      modules: ['Home'],
    }),
    exact: true,
  },
  {
    path: ASSITANT_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "Home" */ './container/assistant/AssistantPage'),
      loading: Loading,
      modules: ['AssistantPage'],
    }),
    exact: true,
  },
  {
    path: AGENT_PROFILE_CONTACT,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "SignIn" */ './container/Agent/AccountDetails/AgentContact'),
      loading: Loading,
      modules: ['AgentContact'],
    }),
  },
  {
    path: LOGIN_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "SignIn" */ './container/SignIn/SignIn'),
      loading: Loading,
      modules: ['SignIn'],
    }),
  },
  {
    path: REGISTRATION_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "SignUp" */ './container/SignUp/SignUp'),
      loading: Loading,
      modules: ['SignUp'],
    }),
  },
  {
    path: REGISTRATION_PAGE2,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "SignUp" */ './container/SignUp/RenderSignUpForm'),
      loading: Loading,
      modules: ['RenderSignUpForm'],
    }),
  },
  {
    path: FORGET_PASSWORD_PAGE,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "ForgetPassWord" */ './container/ForgetPassWord/ForgetPassWord'
        ),
      loading: Loading,
      modules: ['ForgetPassWord'],
    }),
  },
  {
    path: `${SINGLE_POST_PAGE}/:slug`,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "SinglePageView" */ './container/SinglePage/SinglePageView'
        ),
      loading: Loading,
      modules: ['SinglePageView'],
    }),
  },
  {
    path:SIGNIN_ESTIMATION_PAGE, //`${SIGNIN_ESTIMATION_PAGE}/:slug`,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "SignInEstimation" */ './container/SignInEstimation/SignInEstimation'
        ),
      loading: Loading,
      modules: ['SignInEstimation'],
    }),
  },
  {
    path:SIGNUP_ESTIMATION_PAGE, //`${SIGNIN_ESTIMATION_PAGE}/:slug`,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "SignInEstimation" */ './container/SignUpEstimation/SignUpEstimation'
        ),
      loading: Loading,
      modules: ['SignUpEstimation'],
    }),
  },
  {
    path: LISTING_POSTS_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "Listing" */ './container/Listing/Listing'),
      loading: Loading,
      modules: ['Listing'],
    }),
  },
  {
    path: AGENT_PROFILE_PAGE,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "AgentDetailsViewPage" */ './container/Agent/AccountDetails/AgentDetailsViewPage'
        ),
      loading: Loading,
      modules: ['AgentDetailsViewPage'],
    }),
  },
  {
    path: PRIVACY_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "privacy" */ './container/FormEvaluation/EvaluationPage'),
      loading: Loading,
      modules: ['EvaluationPage'],
    }),
  },
  {
    path: PRICING_PLAN_PAGE,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "Pricing" */ './container/Pricing/Pricing'),
      loading: Loading,
      modules: ['Pricing'],
    }),
  },
  
  {
    path: ADD_EVAL_PAGE,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "RenderListingForm" */ './container/FormEvaluation/Wizard'
        ),
      loading: Loading,
      modules: ['Wizard'],
    }),
  },
  {
    path: ADD_HOTEL_PAGE,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "RenderListingForm" */ './container/Listing/RenderListingForm'
        ),
      loading: Loading,
      modules: ['RenderListingForm'],
    }),
  }
];

/**
 *
 * Protected Route Component
 *
 */

/**
 * 
 * {
    path: ADD_HOTEL_PAGE,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "RenderListingForm" */ //'./container/Listing/RenderListingForm'
     //     ),
     //     loading: Loading,
      //    modules: ['RenderListingForm'],
     //   }),
     // },
   /*  {
      path: `${EVALUATION_RESULT_PAGE}/:slug`,
      component: Loadable({
        loader: () =>
          import(
            /* webpackChunkName: "SinglePageView" */ //'./container/SinglePageEvaluation/SinglePageEvaluation'
        //  ),
       //// loading: Loading,
       // modules: ['SinglePageEvaluation'],
      //}),
   // },


const PageEvaluation= Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SinglePageView" */ './container/SinglePageEvaluation/SinglePageEvaluation'
    ),
  loading: Loading,
  modules: ['SinglePageEvaluation'],
});

const AgentAccountSettingsPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AgentAccountSettingsPage" */ './container/Agent/AccountSettings/AgentAccountSettingsPage'
    ),
  loading: Loading,
  modules: ['AgentAccountSettingsPage'],
});

/**
 *
 * Not Found Route Component
 *
 */

const NotFound = Loadable({
  loader: () =>
    import(/* webpackChunkName: "NotFound" */ './container/404/404'),
  loading: Loading,
  modules: ['NotFound'],
});

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { loggedIn } = useContext(AuthContext);
  return (
    <Route
      render={props =>
        loggedIn ? <Component {...props} /> : <Redirect to={LOGIN_PAGE} />
      }
      {...rest}
    />
  );
};

/**
 *
 * Overall Router Component
 * <ProtectedRoute path={ADD_HOTEL_PAGE} component={AddHotel} />
 */

const Routes = () => {
  return (
    <Layout>
      <Switch>
        {routes.map(({ path, component, exact = false }) => (
          <Route key={path} path={path} exact={exact} component={component} />
        ))}
       
        <ProtectedRoute
          path={AGENT_ACCOUNT_SETTINGS_PAGE}
          component={AgentAccountSettingsPage}
        />
        <ProtectedRoute path={`${EVALUATION_RESULT_PAGE}/:slug`} component={PageEvaluation} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
};

export default Routes;
